import { render } from "./BoardNotesBar.vue?vue&type=template&id=f1b0804e"
import script from "./BoardNotesBar.vue?vue&type=script&lang=js"
export * from "./BoardNotesBar.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__